import { ReactComponent as SpypointImage } from 'assets/icons/spypoint.svg'

const SpypointLogo = props => (<SpypointImage {...props} />)

export default SpypointLogo
